export const categories = [
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line", count: 28, description: "烧脑推理、反转不断的高分悬疑欧美剧" },
  { slug: "dongzuo", name: "动作", icon: "ri-fire-line", count: 35, description: "肾上腺素飙升的动作大片级欧美剧集" },
  { slug: "aiqing", name: "爱情", icon: "ri-heart-line", count: 22, description: "浪漫动人的欧美爱情剧集精选" },
  { slug: "kehuan", name: "科幻", icon: "ri-rocket-line", count: 30, description: "脑洞大开的科幻巨制欧美剧" },
  { slug: "xiju", name: "喜剧", icon: "ri-emotion-happy-line", count: 25, description: "笑料不断的欧美喜剧佳作" },
  { slug: "kongbu", name: "恐怖", icon: "ri-ghost-line", count: 18, description: "惊悚刺激的高分恐怖欧美剧" },
];

export const tvShows = [
  {
    id: 1,
    title: "暗夜追踪者",
    titleEn: "Night Tracker",
    category: "xuanyi",
    year: 2024,
    rating: 9.2,
    image: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20crime%20scene%20with%20detective%20silhouette%20against%20city%20night%20lights%2C%20cinematic%20noir%20lighting%2C%20suspenseful%20atmosphere%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20film%20grain%20texture%2C%20professional%20dramatic%20composition&width=800&height=600&seq=tv-show-01&orientation=landscape",
    description: "一位退役FBI探员收到神秘信件，卷入一场跨越三个城市的连环案件。每集一个独立案件，背后却隐藏着惊天阴谋。剧情紧凑、反转不断，被誉为2024年最值得追的悬疑剧。",
    actors: ["迈克尔·法斯宾德", "艾米莉亚·克拉克", "汤姆·希德勒斯顿"],
    episodes: 12,
    status: "连载中"
  },
  {
    id: 2,
    title: "边界战士",
    titleEn: "Border Warriors",
    category: "dongzuo",
    year: 2024,
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Intense%20military%20action%20scene%20with%20special%20forces%20team%20in%20tactical%20gear%2C%20dramatic%20desert%20landscape%2C%20explosive%20dust%20and%20debris%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20composition%2C%20film%20texture&width=800&height=600&seq=tv-show-02&orientation=landscape",
    description: "一支精英特种部队在全球热点地区执行秘密任务。拳拳到肉的近身格斗、震撼的爆炸场面、紧张的战术对抗，每一集都是一部动作大片。",
    actors: ["亨利·卡维尔", "杰森·斯坦森", "斯嘉丽·约翰逊"],
    episodes: 16,
    status: "已完结"
  },
  {
    id: 3,
    title: "巴黎恋习曲",
    titleEn: "Paris Love Notes",
    category: "aiqing",
    year: 2024,
    rating: 9.0,
    image: "https://readdy.ai/api/search-image?query=Romantic%20Paris%20street%20scene%20with%20couple%20walking%20under%20golden%20autumn%20leaves%2C%20warm%20soft%20lighting%2C%20classic%20European%20architecture%20background%2C%20cinematic%20romance%20composition%2C%20elegant%20and%20dreamy%20atmosphere&width=800&height=600&seq=tv-show-03&orientation=landscape",
    description: "一位中国留学生在巴黎邂逅了才华横溢的法国大提琴手，文化差异、家庭阻挠、事业抉择交织成一段跨国恋曲。画面唯美、音乐动人，被誉为年度最浪漫欧美剧。",
    actors: ["莉莉·詹姆斯", "提莫西·查拉梅", "伊娃·格林"],
    episodes: 10,
    status: "连载中"
  },
  {
    id: 4,
    title: "星际纪元：新世界",
    titleEn: "Star Era: New World",
    category: "kehuan",
    year: 2024,
    rating: 9.4,
    image: "https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20interior%20with%20holographic%20displays%20and%20astronauts%2C%20deep%20space%20visible%20through%20large%20viewport%2C%20cool%20metallic%20tones%20with%20warm%20accent%20lights%2C%20cinematic%20sci-fi%20atmosphere%2C%20clean%20minimal%20design&width=800&height=600&seq=tv-show-04&orientation=landscape",
    description: "2147年，人类在系外行星建立首个殖民地。当殖民地与地球失去联络，一支调查小队发现了一个足以改变人类命运的惊天秘密。艾美奖最佳科幻剧提名，特效媲美好莱坞大片。",
    actors: ["基努·里维斯", "赞达亚", "奥斯卡·伊萨克"],
    episodes: 8,
    status: "连载中"
  },
  {
    id: 5,
    title: "疯狂办公室",
    titleEn: "Mad Office",
    category: "xiju",
    year: 2024,
    rating: 8.7,
    image: "https://readdy.ai/api/search-image?query=Modern%20creative%20office%20interior%20with%20colorful%20eclectic%20decor%2C%20diverse%20team%20laughing%20together%2C%20quirky%20startup%20culture%2C%20bright%20warm%20lighting%2C%20playful%20and%20energetic%20atmosphere%2C%20cinematic%20comedy%20composition&width=800&height=600&seq=tv-show-05&orientation=landscape",
    description: "一家硅谷科技创业公司的日常荒诞故事。奇葩同事、刁钻客户、无厘头的产品需求，每一集都让你笑到停不下来。轻松下饭神剧，豆瓣9.0+高分喜剧。",
    actors: ["瑞恩·雷诺兹", "奥卡菲娜", "史蒂夫·卡瑞尔"],
    episodes: 20,
    status: "连载中"
  },
  {
    id: 6,
    title: "古堡幽灵",
    titleEn: "Castle Specter",
    category: "kongbu",
    year: 2024,
    rating: 8.5,
    image: "https://readdy.ai/api/search-image?query=Ancient%20gothic%20castle%20interior%20with%20flickering%20candlelight%2C%20mysterious%20shadows%20on%20stone%20walls%2C%20eerie%20atmosphere%2C%20dark%20rich%20textures%2C%20cinematic%20horror%20composition%2C%20subtle%20warm%20glow%20from%20candles&width=800&height=600&seq=tv-show-06&orientation=landscape",
    description: "一个英国家族继承了苏格兰高地的百年古堡，却发现城堡中隐藏着不为人知的黑暗秘密。氛围感极强、惊悚但不血腥，恐怖剧爱好者不可错过的佳作。",
    actors: ["安雅·泰勒-乔伊", "科林·法瑞尔", "蒂尔达·斯文顿"],
    episodes: 6,
    status: "已完结"
  },
  {
    id: 7,
    title: "真相旋涡",
    titleEn: "Truth Vortex",
    category: "xuanyi",
    year: 2024,
    rating: 9.1,
    image: "https://readdy.ai/api/search-image?query=Crime%20investigation%20board%20with%20photos%20and%20red%20strings%20connecting%20evidence%2C%20detective%20deep%20in%20thought%2C%20rainy%20window%20background%2C%20noir%20cinematic%20lighting%2C%20moody%20and%20intense%20atmosphere&width=800&height=600&seq=tv-show-07&orientation=landscape",
    description: "一名调查记者在追踪一桩旧案时，发现了牵连政商高层的巨大黑幕。每一集都揭示新的线索，直到最后一分钟真相才浮出水面。环环相扣，让人欲罢不能。",
    actors: ["杰克·吉伦哈尔", "蕾切尔·薇兹", "加里·奥德曼"],
    episodes: 10,
    status: "连载中"
  },
  {
    id: 8,
    title: "极速追击",
    titleEn: "Rapid Pursuit",
    category: "dongzuo",
    year: 2024,
    rating: 8.8,
    image: "https://readdy.ai/api/search-image?query=High-speed%20car%20chase%20through%20city%20streets%20at%20night%2C%20motion%20blur%2C%20neon%20lights%20reflecting%20on%20wet%20asphalt%2C%20intense%20action%2C%20cinematic%20dynamic%20composition%2C%20warm%20and%20cool%20light%20contrast&width=800&height=600&seq=tv-show-08&orientation=landscape",
    description: "退役赛车手被迫重出江湖，加入地下赛车组织卧底调查跨国走私案。街头狂飙、极限漂移，每一场赛车戏都让你肾上腺素爆表。",
    actors: ["克里斯·海姆斯沃斯", "盖尔·加朵", "伊德里斯·艾尔巴"],
    episodes: 14,
    status: "连载中"
  },
  {
    id: 9,
    title: "纽约情书",
    titleEn: "NYC Love Letters",
    category: "aiqing",
    year: 2024,
    rating: 8.6,
    image: "https://readdy.ai/api/search-image?query=Couple%20sharing%20coffee%20at%20a%20cozy%20New%20York%20cafe%20with%20rainy%20window%20view%2C%20warm%20intimate%20lighting%2C%20brick%20wall%20texture%2C%20romantic%20urban%20atmosphere%2C%20cinematic%20composition%2C%20soft%20focus&width=800&height=600&seq=tv-show-09&orientation=landscape",
    description: "纽约布鲁克林，两个陌生人在二手书店因一本旧书结缘。慢节奏的都市爱情故事，细腻的情感刻画让人回味无穷。适合在周末午后细细品味。",
    actors: ["西尔莎·罗南", "安德鲁·加菲尔德", "凯特·布兰切特"],
    episodes: 8,
    status: "已完结"
  },
  {
    id: 10,
    title: "量子深渊",
    titleEn: "Quantum Abyss",
    category: "kehuan",
    year: 2024,
    rating: 9.3,
    image: "https://readdy.ai/api/search-image?query=Quantum%20physics%20laboratory%20with%20glowing%20particle%20trails%20and%20equations%20floating%20in%20air%2C%20scientist%20observing%20phenomenon%2C%20warm%20amber%20and%20cool%20cyan%20contrast%2C%20cinematic%20sci-fi%20composition&width=800&height=600&seq=tv-show-10&orientation=landscape",
    description: "量子物理学家在一次实验中意外打开了平行宇宙的通道。多个世界线交织、时间悖论频现，堪称科学与哲学完美结合的硬核科幻神作。",
    actors: ["本尼迪克特·康伯巴奇", "娜塔莉·波特曼", "马赫沙拉·阿里"],
    episodes: 10,
    status: "连载中"
  },
  {
    id: 11,
    title: "隔壁的怪邻居",
    titleEn: "Strange Neighbors",
    category: "xiju",
    year: 2024,
    rating: 8.4,
    image: "https://readdy.ai/api/search-image?query=Suburban%20neighborhood%20street%20with%20quirky%20colorful%20houses%2C%20eccentric%20characters%20peeking%20from%20behind%20fences%2C%20warm%20sunny%20day%2C%20playful%20comedic%20atmosphere%2C%20cinematic%20composition&width=800&height=600&seq=tv-show-11&orientation=landscape",
    description: "搬进新社区的一家人发现，他们的邻居一个比一个奇葩。从后院养羊驼的环保主义者到每晚开派对的退休DJ，笑料不断、温馨治愈。",
    actors: ["威尔·法瑞尔", "玛格特·罗比", "比尔·哈德尔"],
    episodes: 18,
    status: "连载中"
  },
  {
    id: 12,
    title: "暗影森林",
    titleEn: "Shadow Forest",
    category: "kongbu",
    year: 2024,
    rating: 8.3,
    image: "https://readdy.ai/api/search-image?query=Dark%20dense%20forest%20with%20fog%20and%20mysterious%20glowing%20eyes%20between%20trees%2C%20moonlight%20filtering%20through%20canopy%2C%20eerie%20atmospheric%20horror%2C%20cinematic%20composition%2C%20deep%20warm%20and%20cool%20contrast&width=800&height=600&seq=tv-show-12&orientation=landscape",
    description: "一群大学生前往北欧原始森林露营，却遭遇了古老传说中的神秘生物。封闭空间、逐渐减少的成员，经典恐怖片元素与现代叙事完美结合。",
    actors: ["弗洛伦丝·皮尤", "尼古拉斯·霍尔特", "米娅·高斯"],
    episodes: 8,
    status: "已完结"
  },
];

export const reviews = [
  {
    id: 1,
    name: "追剧达人小王",
    rating: 5,
    content: "红桃影视大全真的是我见过更新最快的欧美剧平台！暗夜追踪者刚在美国播出，这边第二天就有中文字幕版了，画质也很棒，强烈推荐！",
    date: "2024-12-20"
  },
  {
    id: 2,
    name: "影视爱好者Lily",
    rating: 5,
    content: "字幕质量真的没话说，中英双语对照，翻译准确而且接地气。星际纪元这种硬核科幻剧都能翻译得这么好，翻译团队真的很用心。",
    date: "2024-12-18"
  },
  {
    id: 3,
    name: "老陈聊剧",
    rating: 5,
    content: "分类做得很清晰，悬疑、科幻、爱情分门别类，找剧很方便。1080P画质在手机和平板上看都很清晰，已经推荐给身边所有追欧美剧的朋友了。",
    date: "2024-12-15"
  },
  {
    id: 4,
    name: "小美追剧ing",
    rating: 4,
    content: "巴黎恋习曲每一集都让我看哭，画面太美了！而且没有广告打断，观影体验很流畅。唯一希望是能再多上一些经典老剧。",
    date: "2024-12-12"
  },
  {
    id: 5,
    name: "科技宅大刘",
    rating: 5,
    content: "量子深渊这种硬核科幻能找到这么高质量的资源真的不容易。网站的推荐算法也挺准的，每次都能给我推荐到喜欢的新剧。",
    date: "2024-12-10"
  },
  {
    id: 6,
    name: "周末追剧猫",
    rating: 5,
    content: "每周五晚上准时蹲更新，已经成了我的固定节目。疯狂办公室太好笑了，弹幕也很有趣，一个人看也不会觉得孤单。",
    date: "2024-12-08"
  },
];